import { Component, Input, OnInit } from '@angular/core';

import { User, UserService } from '@fry/lib/users';
import { AuthService } from '@fry/lib/auth';
import { EASButtonAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';

@Component({
    selector: 'app-user-slot',
    templateUrl: './user-slot.component.html',
    providers: [
        UserService
    ],
    standalone: false
})
export class UserSlotComponent implements OnInit {
  @Input() user: User;

  public fullname: string;
  public state: string;
  public buttons: EASButtonAction[] = [
    {
      type: 'button',
      label: $localize `Login as this user`,
      condition: () => this.security.hasPermissionFor('users.lase', this.user.doc.user),
      click: () => this.auth.loginAs(this.user.doc.user)
    }
  ];

  constructor(
      private userService: UserService,
      private auth: AuthService,
      private security: SecurityService,
  ) { }

  ngOnInit() {
      this.userService.setUser(this.user);
      this.fullname = this.userService.fullname();
      this.state = this.user.stateName;
  }

  onSubmit() {
  }
}
